import React, {useEffect, useState} from "react";
import {ExpandModal} from "./ExpandModal";
import {Button, Stack, Typography} from "@mui/material";
import {Editor} from "@monaco-editor/react";
import {CopyCodeButton} from "../CopyCodeButton";

export const ParserModal = ({open, handleClose, text, onSuccess}) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (open) {
      setContent(text || "");
    }
  }, [open, text])

  return (
    <ExpandModal
      open={open}
      handleClose={handleClose}
    >
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
        <Typography fontWeight={700}>Parser</Typography>
        {/* copies what is in the editor now, including edits that are not saved yet */}
        <CopyCodeButton text={content} size={17}/>
      </Stack>
      <Editor
        // height="80%"
        style={{flex: 1}}
        defaultLanguage="javascript"
        value={content || ""}
        onChange={(value, e) => setContent(value)}

      />
      <Stack direction={"row"} gap={2} alignItems={"center"}>
        <Button
          variant={"modal"}
          color={"secondary"}
          onClick={() => {
            onSuccess(content);
            setContent("");
            handleClose();
          }}
        >
          Save
        </Button>
        <Button
          variant={"ghost"}
          color={"secondary"}
          onClick={() => {
            setContent("");
            handleClose();
          }}
        >
          Cancel
        </Button>
      </Stack>
    </ExpandModal>
  )
}